export enum DigitalChannelStatus {
    NEW = 'new',
    OPEN = 'open',
    RESOLVED = 'resolved'
   }